import {FC, useEffect, useMemo, useState} from 'react'

import 'bootstrap-icons/font/bootstrap-icons.css'
import './Wizardstep.scss'

import moment from 'moment'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {useLocation} from 'react-router-dom'
import {toast} from 'react-toastify'
import {ulid} from 'ulid'
import {KTSVG, countWords, toAbsoluteUrl, useDebounce} from '../../../../../_metronic/helpers'
import {useGetAllTagsQuery, useLazyGetGroupQuery} from '../../../../../services/cellcast'
import AlertMessageBox from '../../../../Components/AlertMessageBox'
import ContectListsPopup from '../../../../Components/ContectListsPopup'
import ContectSegmentListsPopup from '../../../../Components/ContectSegmentListsPopup'
import {FirstTimeApprovalData} from '../../../../Components/PopupSlice/popupSlice'
import PurchasePopup from '../../../../Components/PurchasePopup'
import SuccessPopup from '../../../../Components/SuccessPopup'
import {useTimezone} from '../../../../hooks/useTimezone'
import {stopLoadingSend} from '../../../../Redux/FrontEnd/Loading/LoadingSendSlice'
import {stopLoading} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {fetchAsyncQuickMms} from '../../../../Redux/FrontEnd/QuickMessageSlice/quickMmsSlice'
import {fetchAsyncQuickSms} from '../../../../Redux/FrontEnd/QuickMessageSlice/QuickSmsSlice'
import {base64ToFile, replaceMessageWith} from '../../../../Utils/_helpers'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'
import {GeneralDataOFLoginUser} from '../../../../Utils/Auth'
import {GLOBAL_SETTINGS_TYPE} from '../../../../Utils/Constant/ConstantForWebsite'
import {
  fetchAsyncUserDetails,
  getDefaultOptOutUrl,
  getDefaultShortUrl,
} from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {GetAllData} from '../../Contacts/Segments/SegmentSlice/SegmentSlice'
import {GetAllData as GetAllOptoutData} from '../../Opt_out/OptoutSlice/OptoutListSlice'
import {storeReportId} from '../../reports-analytics/reportSlices/reportAnalytics'
import {
  BulkMessageReview,
  BulkMsgDraftData,
  SaveCampaigsData,
  UpdateSaveCampaigsData,
  getReviewData,
  sendBulkMessageData,
  sendBulkMessagemmsData,
  totalCounts,
  totalRecipients,
} from '../BulkMessageSlice/BulkMessageSlice'
import BulkMessageMesssageBoxV2 from './Bulk_Message_Message/Bulk_Message_MesssageBoxV2'
import BulkMessageSendFromV2 from './Bulk_Message_Send_From/Bulk_Message_Send_From_V2'
import BulkMessageSendToV2 from './Bulk_Message_Send_To/BulkMessageSendToV2'
import BulkMessagewhenv2 from './Bulk_Message_When/Bulk_Message_when_v2'
import GettingStartedV2 from './GettingStarted/GettingStartedV2'
import ReviewBulkMessageData from './ReviewBulkMessageData'
import {isBase64Image} from '../../../../Utils/AllHelperFunctions'
import VCardPreview from '../../../../Components/VCardPreview'
import {useNewMessage} from '../useNewMessage'
import {useFetchTagQuery} from '../../../../../services/cellcast.v3'
import Stepper from '../../../../Components/Stepper'

export const bulkMessageStateV2 = {
  name: '',
  campaign_type: 'promotional',
  previouslySendId: {value: '', label: 'Select'},
  saveCampaignId: '',
  camp_type: 'sms',
  media: '',
  gif: '',
  message: '',
  messageSecond: '',
  subject: '',
  abTest: false,
  optout: false,
  optoutSecond: false,
  replyStopToOptOut: true,
  replyStopToOptOutSecond: true,
  to: {
    selectedType: '',
    value: '',
    exclude: false,
    excludeTags: '',
  },
  longUrl: [],
  longUrlSecond: [],
  when: '',
  whenSecond: '',
  sender: {value: '', label: ''},
  selectedTemplate: {value: '', label: 'Select Template'},
  interval: '',
  quantity: '',
  staggerMessages: false,
  isIntervalSend: false,
  landingPageId: '',
  landingPageIdSecond: '',
  senderType: '',
  filetype: '',
  url: '',
  mediaType: '',
  fileName: '',
  scheduledAt: new Date(),
  scheduledAtSecond: new Date(),
  forwardReplyTo: '',
}
const NewMessageStepperV2: FC = () => {
  const ReviewData = useSelector(getReviewData)
  const isAdmin = localStorage.getItem('isAdmin')
  const param: any = useLocation()
  const dispatch = useDispatch()
  const credits = useSelector((state: any) => state?.userDetails?.userDetails?.data)
  const optOutUrl = useSelector(getDefaultOptOutUrl)
  const defaultShortUrl = useSelector(getDefaultShortUrl)
  ///////////////////////////////////USE STATE////////////////////
  const [testNumber, setTestNumber] = useState()
  const [showAlert, setShowAlert] = useState(false)
  const [alertMessage, setAlertMessage] = useState('')
  const [error, setError] = useState<any>({})
  const [review, setReview] = useState(false)
  const [sendFlag, setSendFlag] = useState(false)
  const [bulkMessageData, setBulkMessageData] = useState<any>(bulkMessageStateV2)

  const ShortLinkList = useSelector((state: any) => state?.ShortLink?.allTrackingLinks)

  const [successPopupModal, setSuccessPopupModal] = useState<any>(false)
  const userData: any = GeneralDataOFLoginUser()?.globalSettingData?.[0]?.value
  const [purchasePopupModal, setPurchasePopupModal] = useState<any>(false)
  const [contectListModel, setContectListModel] = useState<any>(false)
  const [firstTimeSend, setFirstTimeSend] = useState<any>(false)
  const [contectSegmentListModel, setSegmentContectListModel] = useState<any>(false)
  const [mmsError, setMMSError] = useState<any>(false)
  const [purchaseModelData, setPurchaseModelData] = useState({
    type: '',
    purchaseCredit: 0,
    minimum: 0,
  })
  const [checkStep, setCheckStep] = useState({
    gettingStarted: true,
    to: false,
    from: false,
    message: false,
    when: false,
  })
  const [sendError, setSendError] = useState('')
  const [segmentAndTags, setSegmentAndTags] = useState<any>([])
  const [bulkULID, setBulkULID] = useState('')
  const [completedSteps, setCompletedSteps] = useState({
    gettingStarted: false,
    to: false,
    from: false,
    message: false,
    when: false,
  })
  const isAllStepCompleted = useMemo(
    () => Object.values(completedSteps).every((step) => step),
    [completedSteps]
  )
  const {toLocalTimezone} = useTimezone()
  const [isForwardIncomingMessage, setIsForwardIncomingMessage] = useState(false)
  const {isDefaultRegion, sendCalculateSummary, sendFinalMessage} = useNewMessage()
  const [selectedTagIds, setSelectedTagIds] = useState<any>([])
  const [searchTag, setSearchTag] = useState<string>('')
  const [previewIndex, setPreviewIndex] = useState(0)
  const debouncedSearchTerm = useDebounce(searchTag, 500)

  useEffect(() => {
    setPreviewIndex(0)
  }, [ReviewData?.previews])

  /////////////////////////////USE SELECTOR//////////////////////
  const {data: tagList} = useGetAllTagsQuery({})
  const {tagRegion} = useFetchTagQuery(
    {type: 'tag', limit: 1000},
    {
      selectFromResult: ({data}) => {
        return {
          tagRegion: data
            ? data?.data?.items
                ?.filter((val: any) => val.type !== 'list' && val?.isHidden === false)
                .map((val: any) => ({value: `tag_${val?._id}`, label: val?.name, group: 'tag'}))
            : [],
        }
      },
      skip: isDefaultRegion,
    }
  )

  const optoutList = useSelector((state: any) => {
    const userGlobalSettings = state?.userDetails?.userDetails?.data?.user?.globalSetting
    let list = state?.optoutList?.optoutList?.data?.items || []

    if (bulkMessageData?.camp_type === 'sms') {
      const isDisableReplyByGlobalOption = userGlobalSettings?.includes(
        GLOBAL_SETTINGS_TYPE.BULK_SMS_REPLY_STOP_OUTPUT
      )
      list = isDisableReplyByGlobalOption ? list : []
    }

    if (bulkMessageData?.camp_type === 'mms') {
      const isDisableReplyByGlobalOption = userGlobalSettings?.includes(
        GLOBAL_SETTINGS_TYPE.BULK_MMS_REPLY_STOP_OUTPUT
      )
      list = isDisableReplyByGlobalOption ? list : []
    }

    return list
  })

  const Segmentlist: any = useSelector((state: any) => state?.SegmentData?.segmaent?.data?.items)
  const draftData = useSelector((state: any) => state?.bulkMessageData?.BulkMsgDraftData)

  const globalSettings = useSelector(
    (state: any) => state?.userDetails?.userDetails?.data?.user?.globalSetting
  )
  const [getGroup, {data: groupData}] = useLazyGetGroupQuery()

  useEffect(() => {
    let data = param?.state?.data

    if (data && data.optout && data.optout === true) {
      data.message = data.message.replace('\nSTOP: stoptxt.au/vc', '')
    }

    if (data && data.optoutSecond && data.optoutSecond === true) {
      data.messageSecond = data?.messageSecond.replace('\nSTOP: stoptxt.au/vc', '')
    }

    if (data && data.replyStopToOptOut && data.replyStopToOptOut === true) {
      data.message = data.message.replace("\nReply 'STOP' to opt-out", '')
    }

    if (data && data.replyStopToOptOutSecond && data.replyStopToOptOutSecond === true) {
      data.messageSecond = data?.messageSecond.replace("\nReply 'STOP' to opt-out", '')
    }

    if (data && data?.forwardReplyTo && data?.forwardReplyTo !== '') {
      setIsForwardIncomingMessage(true)
    }

    param?.state?.selectedType === 'draft' &&
      setBulkMessageData({
        ...bulkMessageData,
        ...data,
        saveCampaignId: param?.state?.data?.saveCampaignId,
      })
    if (param?.state !== '' && param?.state?.selectedType !== 'draft') {
      param?.state === 'all' &&
        setBulkMessageData({
          ...bulkMessageData,
          to: {
            selectedType: 'all',
            value: 'all',
          },
        })

      console.log('🚀 ~ NewMessageStepperV2 ~ param?.state?.data:', param?.state?.data)

      param?.state?.selectedType === 'segmentOrTags' &&
        setBulkMessageData({
          ...bulkMessageData,
          to: {
            selectedType: param?.state?.selectedType,
            value: [param?.state?.data],
          },
        })

      param?.state?.selectedType === 'contacts' &&
        setBulkMessageData({
          ...bulkMessageData,
          contacts: param?.state?.data,
          to: {
            selectedType: param?.state?.selectedType,
            value: '',
          },
        })

      if (!param?.state?.selectedType) {
        setBulkMessageData(draftData ?? bulkMessageStateV2)
      }

      window.history.replaceState({}, document.title)
    }

    // Handle when disable reply stop out and opt out link
    if (!optoutList?.length) {
      const payload = {
        replyStopToOptOut: false,
        optout: false,
        optoutId: '',
        replyStopToOptOutSecond: false,
      }

      setBulkMessageData({
        ...bulkMessageData,
        ...payload,
      })
    }

    if (
      ['businessName', 'customNumber'].includes(bulkMessageData?.senderType) &&
      optoutList?.length > 0
    ) {
      const payload = {
        replyStopToOptOut: false,
        optout: true,
        optoutId: optoutList?.at(0)?._id ?? '',
        replyStopToOptOutSecond: false,
        optoutLabel: optoutList?.at(0)?.title ?? '',
      }

      setBulkMessageData({
        ...bulkMessageData,
        ...payload,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!optoutList?.length) {
      setBulkMessageData((prev: any) => ({
        ...prev,
        replyStopToOptOut: false,
        optout: false,
        optoutId: '',
        replyStopToOptOutSecond: false,
      }))
    } else {
      setBulkMessageData((prev: any) => {
        if (!prev.optout && !prev.replyStopToOptOut) {
          if (['businessName', 'customNumber'].includes(prev.senderType)) {
            return {
              ...prev,
              replyStopToOptOut: false,
              replyStopToOptOutSecond: false,
              optout: true,
              optoutId: optoutList?.at(0)?._id ?? '',
              optoutLabel: optoutList?.at(0)?.title ?? '',
            }
          }
          return {
            ...prev,
            replyStopToOptOut: true,
            replyStopToOptOutSecond: true,
          }
        }
        return prev
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [optoutList?.length])

  const updateCompletedStepss = (data: any) => {
    setCompletedSteps({
      gettingStarted: !!data.name,
      to:
        (data?.to?.selectedType !== '' && data?.to?.value !== '') ||
        (data?.contacts && data?.contacts?.length > 0),
      from: data.sender !== '' && data?.senderType !== '',
      message: data.message !== '' && data.camp_type !== '',
      when: !!data.when,
    })
  }

  useEffect(() => {
    // Check completion status of each step based on bulkMessageData
    updateCompletedStepss(bulkMessageData)
  }, [bulkMessageData])

  useEffect(() => {
    dispatch(totalRecipients({to: bulkMessageData?.to}))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bulkMessageData?.to?.value, bulkMessageData?.to?.exclude, bulkMessageData?.to?.excludeTags])

  useEffect(() => {
    dispatch(
      totalCounts({
        to: {
          selectedType: 'all',
          value: 'all',
        },
      })
    )

    getGroup(null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    let segmentOption =
      Segmentlist?.map((key: any) => {
        return {
          value: `segment_${key?._id}`,
          label: `${key?.name}`,
          group: 'segment',
        }
      }) || []

    const normalTags = tagList?.data?.filter(
      (key: any) => !key?.type || (key.type && key.type !== 'list')
    )
    const listTags = tagList?.data?.filter((key: any) => key.type && key.type === 'list')

    let tagsOption =
      normalTags?.map((key: any) => {
        return {
          value: `tag_${key?._id}`,
          label: `${key?.name}`,
          group: 'tag',
        }
      }) || []

    let listOption =
      listTags?.map((key: any) => {
        return {
          value: `tag_${key?._id}`,
          label: `${key?.name}`,
          group: 'list',
        }
      }) || []

    // eslint-disable-next-line no-lone-blocks
    {
      isDefaultRegion
        ? setSegmentAndTags([
            {
              label: 'List',
              options: listOption,
            },
            {
              label: 'Segment',
              options: segmentOption,
            },
            {
              label: 'Tags',
              options: tagsOption,
            },
          ])
        : setSegmentAndTags([
            {
              label: 'Tags',
              options: tagRegion,
            },
          ])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Segmentlist, tagList])

  const rawOptoutItems = useSelector((state: any) => state?.optoutList?.optoutList?.data?.items)

  ////Featch all getting started data
  useEffect(() => {
    dispatch(fetchAsyncUserDetails())
    // Fetch optout data if not already loaded (e.g., user bypassed dashboard via redirect URL)
    if (!rawOptoutItems?.length) {
      dispatch(GetAllOptoutData())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    dispatch(
      GetAllData({
        page: 1,
        size: 75,
        search: debouncedSearchTerm ?? '',
      })
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Segmentlist?.total, debouncedSearchTerm])

  const handleSearchTag = (value?: string | null) => {
    setSearchTag(value || '')
  }

  ////////////////////////////////////////Save Campaign data ////////////////////////////////////
  const handleSaveData = () => {
    if (bulkMessageData.name === '') {
      setAlertMessage('Please provide campaign name')
      setShowAlert(true)
    } else {
      let finalData = {
        ...bulkMessageData,
        to: JSON.stringify(bulkMessageData.to),
        longUrl: JSON.stringify(bulkMessageData?.longUrl),
      }

      let mediaData = finalData?.media ?? ''
      if (typeof mediaData == 'string') {
        if (mediaData?.startsWith('data:')) {
          mediaData = base64ToFile(mediaData)
        }
      }

      let formData = new FormData()
      let values: any = {
        camp_type: finalData?.camp_type,
        to: finalData?.to,
        message: finalData?.message,
        name: finalData?.name,
        optout: finalData.optout ? finalData.optout : false,
        landingPage: finalData.landingPage ? finalData.landingPage : false,
        sender: finalData?.sender?.value,
        gif: finalData?.gif ? finalData?.gif : '',
        media: mediaData ? mediaData : '',
        senderType: finalData?.senderType,
        longUrl: finalData?.longUrl,
        subject: finalData?.subject,
      }

      if (finalData && finalData.landingPageId && finalData.landingPageId.length > 0) {
        values.landingPage = true
        values.landingPageId = finalData.landingPageId
      }

      if (finalData?.optout && finalData?.optout === true && finalData?.optoutId) {
        values.optoutId = finalData?.optoutId
      }

      if (finalData?.replyStopToOptOut) {
        values.replyStopToOptOut = finalData?.replyStopToOptOut
      }

      if (finalData?.forwardReplyTo) {
        values.forwardReplyTo = finalData?.forwardReplyTo
      }

      for (var key in values) {
        formData.append(key, values[key])
      }

      if (bulkMessageData?.saveCampaignId !== '' && bulkMessageData?.saveCampaignId !== undefined) {
        dispatch(
          UpdateSaveCampaigsData({id: bulkMessageData.saveCampaignId?.value, data: formData})
        )
      } else {
        dispatch(SaveCampaigsData(formData))
      }
    }
  }
  const landingPageUrl = `${defaultShortUrl}/Lxxxxx`

  const extractLongUrls = (message: any) => {
    if (!message || !message.includes(defaultShortUrl) || message.includes(landingPageUrl)) {
      return []
    }

    const regex = new RegExp(`${defaultShortUrl.replace(/\./g, '\\.')}\\/([a-zA-Z0-9_-]+)`, 'gmi')
    const matches = [...message.matchAll(regex)].map((match) => match.at(1))
    const uniqueMatches = new Set(matches)

    return ShortLinkList.map((it: any) => ({
      _id: it._id,
      shortUrl: it.shortUrl,
      longUrl: it.upstreamUrl,
    })).filter((it: any) => uniqueMatches.has(it.shortUrl))
  }

  /////////////////////////////////////Review Campaign data//////////////////
  const handelSendData = async () => {
    // validation(bulkMessageData)

    const tempBulkULID = ulid()
    // set ulid
    setBulkULID(tempBulkULID)

    if (Object.keys(validation(bulkMessageData))?.length <= 0) {
      const tmpData = {...bulkMessageData}
      const mmsData = {
        ...tmpData,
        ulid: tempBulkULID,
        message: tmpData?.message,
        messageSecond: tmpData?.messageSecond,
        media: {
          filetype: tmpData?.filetype,
          url: tmpData?.url,
          mediaType: 'image',
          fileName: tmpData?.fileName,
        },
      }

      // overide long url with shorlink list from db
      if (
        mmsData?.message?.includes(defaultShortUrl) &&
        !mmsData?.message?.includes(landingPageUrl)
      ) {
        mmsData.longUrl = extractLongUrls(bulkMessageData.message)
      }

      if (
        mmsData?.messageSecond?.includes(defaultShortUrl) &&
        !mmsData?.messageSecond?.includes(landingPageUrl)
      ) {
        mmsData.longUrlSecond = extractLongUrls(mmsData.message)
      }

      mmsData.landingPage = bulkMessageData?.landingPageId ? true : false
      mmsData.landingPageSecond = bulkMessageData?.landingPageIdSecond ? true : false

      mmsData.message = replaceMessageWith(mmsData.message, '')
      mmsData.messageSecond = replaceMessageWith(mmsData.messageSecond, '')

      if (mmsData && mmsData.scheduledAt) {
        mmsData.scheduledAt = toLocalTimezone(mmsData.scheduledAt)
      }

      if (bulkMessageData?.to?.selectedType === 'contacts') {
        delete mmsData.to
      }

      if (mmsData?.camp_type === 'mms') {
        if (mmsData.senderType === 'businessName' || mmsData.senderType === 'customNumber') {
          setMMSError(true)
          setError({...error, sender: 'Select sender  is required'})
        } else {
          dispatch(BulkMessageReview(mmsData))
            .then((res: any) => {
              if (res.type && res.type === 'BulkMessageReview/rejected') {
                toast.error(res?.payload)
              } else {
                if (res?.payload?.success == false) {
                  toast.error(res?.payload?.message)
                } else {
                  setReview(true)
                }
              }
            })
            .catch((error: any) => {
              toast.error(error)
            })
        }
      } else {
        if (isDefaultRegion) {
          dispatch(BulkMessageReview(mmsData))
            .then((res: any) => {
              if (res.type && res.type === 'BulkMessageReview/rejected') {
                toast.error(res?.payload)
              } else {
                if (res?.payload?.success === false || res?.payload?.status === false) {
                  toast.error(res?.payload?.message)
                } else {
                  setReview(true)
                }
              }
            })
            .catch((error: any) => {
              toast.error(error)
            })
        } else {
          // For other region
          if (mmsData?.senderType === 'dedicatedNumber') {
            mmsData.senderType = 'dedicated'
          }

          if (mmsData.senderType === 'businessName') {
            mmsData.senderType = 'business'
          }

          if (mmsData.senderType === 'customNumber') {
            mmsData.senderType = 'custom'
          }

          const result = await sendCalculateSummary(mmsData)
          if (result?.status === false) {
            toast.error(result?.message)
          } else {
            setReview(true)
          }
        }
      }
    }
  }

  const successModal = useMemo(
    () => (
      <SuccessPopup
        show={successPopupModal}
        backdrop={true}
        bulkMessageData={bulkMessageData}
        firstTimeSend={firstTimeSend}
        errorMessage={sendError}
        handleClose={() => {
          setReview(false)
          if (sendError !== '') {
            setSendError('')
            setBulkMessageData(bulkMessageData)
            dispatch(
              BulkMsgDraftData({
                ...bulkMessageData,
              })
            )
          } else {
            setBulkMessageData(bulkMessageStateV2)
            dispatch(
              BulkMsgDraftData({
                ...bulkMessageStateV2,
                scheduledAt: '',
              })
            )
          }

          setSuccessPopupModal(false)
          dispatch(stopLoading())
          setFirstTimeSend(false)
        }}
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [successPopupModal, sendError]
  )
  const purchaseModal = useMemo(
    () => (
      <PurchasePopup
        show={purchasePopupModal}
        purchaseModelData={purchaseModelData}
        handleClose={() => {
          setPurchasePopupModal(false)
        }}
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [purchasePopupModal]
  )

  const contectListPopup = useMemo(
    () => (
      <ContectListsPopup
        show={contectListModel}
        handleClose={() => {
          setContectListModel(false)
        }}
        status={'subscribed'}
      />
    ),
    [contectListModel]
  )

  const contectSegmentListPopup = useMemo(
    () => (
      <ContectSegmentListsPopup
        show={contectSegmentListModel}
        selectedData={bulkMessageData?.to}
        handleClose={() => {
          setSegmentContectListModel(false)
        }}
      />
    ),
    [contectSegmentListModel, bulkMessageData]
  )

  const sendBulkMessage = async (e: any) => {
    const minimumCredit =
      bulkMessageData?.camp_type === 'sms'
        ? Number(userData?.MIN_PURCHASES_SMS_CERDIT ?? 20)
        : Number(userData?.MIN_PURCHASES_MMS_CERDIT ?? 20)

    // overide long url with shorlink list from db
    const landingPageUrl = `${defaultShortUrl}/Lxxxxx`

    if (
      bulkMessageData?.message?.includes(defaultShortUrl) &&
      !bulkMessageData?.message?.includes(landingPageUrl)
    ) {
      bulkMessageData.longUrl = extractLongUrls(bulkMessageData.message)
    }

    if (
      bulkMessageData?.messageSecond?.includes(defaultShortUrl) &&
      !bulkMessageData?.messageSecond?.includes(landingPageUrl)
    ) {
      bulkMessageData.longUrlSecond = extractLongUrls(bulkMessageData.messageSecond)
    }

    if (
      moment().add(5, 'minutes').isBefore(moment(bulkMessageData?.scheduledAt)) ||
      bulkMessageData?.when === 'now' ||
      moment().add(5, 'minutes').isBefore(moment(bulkMessageData?.scheduledAtSecond)) ||
      bulkMessageData?.whenSecond === 'now'
    ) {
      if (bulkMessageData?.camp_type === 'sms') {
        const iid =
          bulkMessageData?.landingPageId !== '' && bulkMessageData?.landingPageId !== undefined

        let smsDataToSend: any = {
          ulid: bulkULID,
          sender: bulkMessageData?.sender?.value,
          senderType: bulkMessageData?.senderType,
          message: bulkMessageData?.message,
          camp_type: bulkMessageData?.camp_type,
          name: bulkMessageData.name,
          landingPage: bulkMessageData.landingPageId ? true : false,
          optout: bulkMessageData?.optout ? bulkMessageData?.optout : false,
          replyStopToOptOut: bulkMessageData?.replyStopToOptOut
            ? bulkMessageData?.replyStopToOptOut
            : false,
          abTest: bulkMessageData?.abTest,
          messageSecond: bulkMessageData?.messageSecond,
          landingPageSecond: bulkMessageData.landingPageIdSecond ? true : false,
          optoutSecond: bulkMessageData?.optoutSecond ? bulkMessageData?.optoutSecond : false,
          replyStopToOptOutSecond: bulkMessageData?.replyStopToOptOutSecond
            ? bulkMessageData?.replyStopToOptOutSecond
            : false,
        }

        if (bulkMessageData?.contacts?.length > 0 && bulkMessageData?.contacts !== undefined) {
          smsDataToSend.contacts = bulkMessageData?.contacts
        } else {
          smsDataToSend.to = JSON.stringify(bulkMessageData.to)
        }
        if (bulkMessageData?.staggerMessages === true) {
          smsDataToSend.staggerMessages = bulkMessageData?.staggerMessages
          smsDataToSend.interval = bulkMessageData?.interval
          smsDataToSend.quantity = bulkMessageData?.quantity
        }
        if (bulkMessageData?.isIntervalSend === true) {
          smsDataToSend.isIntervalSend = bulkMessageData?.isIntervalSend
          smsDataToSend.interval = bulkMessageData?.interval
        }
        if (bulkMessageData?.longUrl !== '') {
          smsDataToSend.longUrl = bulkMessageData?.longUrl
        }
        if (bulkMessageData?.longUrlSecond !== '') {
          smsDataToSend.longUrlSecond = bulkMessageData?.longUrlSecond
        }
        if (
          bulkMessageData?.optoutId !== '' &&
          bulkMessageData?.optoutId !== undefined &&
          bulkMessageData?.optoutId !== null
        ) {
          smsDataToSend.optoutId = bulkMessageData?.optoutId
        }
        if (
          bulkMessageData?.optoutIdSecond !== '' &&
          bulkMessageData?.optoutIdSecond !== undefined &&
          bulkMessageData?.optoutIdSecond !== null
        ) {
          smsDataToSend.optoutIdSecond = bulkMessageData?.optoutIdSecond
        }
        if (bulkMessageData?.when !== 'now') {
          smsDataToSend.scheduleAt = bulkMessageData?.scheduledAt
        }

        if (bulkMessageData?.whenSecond !== 'now') {
          smsDataToSend.scheduleAtSecond = bulkMessageData?.scheduledAtSecond
        }

        if (bulkMessageData.landingPageId !== '') {
          smsDataToSend.landingPageId = bulkMessageData.landingPageId
        }
        if (bulkMessageData.landingPageIdSecond !== '') {
          smsDataToSend.landingPageIdSecond = bulkMessageData.landingPageIdSecond
        }

        if (bulkMessageData?.forwardReplyTo !== '') {
          smsDataToSend.forwardReplyTo = bulkMessageData?.forwardReplyTo
        }

        if (!globalSettings?.includes(GLOBAL_SETTINGS_TYPE.BULK_SMS_REPLY_STOP_OUTPUT)) {
          smsDataToSend = {
            ...smsDataToSend,
            optout: false,
            replyStopToOptOut: false,
            optoutSecond: false,
            replyStopToOptOutSecond: false,
          }
        } else {
          const isAlphaSender = ['businessName', 'customNumber'].includes(
            bulkMessageData?.senderType
          )
          if (!smsDataToSend.optout && !smsDataToSend.replyStopToOptOut) {
            if (isAlphaSender) {
              smsDataToSend.replyStopToOptOut = false
              smsDataToSend.optout = true
              smsDataToSend.optoutId = smsDataToSend.optoutId || optoutList?.at(0)?._id || ''
            } else {
              smsDataToSend.replyStopToOptOut = true
            }
          }
          if (
            smsDataToSend.abTest &&
            !smsDataToSend.optoutSecond &&
            !smsDataToSend.replyStopToOptOutSecond
          ) {
            if (isAlphaSender) {
              smsDataToSend.replyStopToOptOutSecond = false
              smsDataToSend.optoutSecond = true
              smsDataToSend.optoutIdSecond =
                smsDataToSend.optoutIdSecond || optoutList?.at(0)?._id || ''
            } else {
              smsDataToSend.replyStopToOptOutSecond = true
            }
          }
        }

        if (smsDataToSend && smsDataToSend.scheduleAt) {
          smsDataToSend.scheduleAt = toLocalTimezone(smsDataToSend.scheduleAt)
        }

        if (smsDataToSend && smsDataToSend.scheduleAtSecond) {
          smsDataToSend.scheduleAtSecond = toLocalTimezone(smsDataToSend.scheduleAtSecond)
        }

        smsDataToSend.message = replaceMessageWith(smsDataToSend.message, '')
        smsDataToSend.messageSecond = replaceMessageWith(smsDataToSend.messageSecond, '')

        smsDataToSend.tagNewContactIds = selectedTagIds

        if (credits?.credits?.[bulkMessageData?.camp_type] < ReviewData?.draftDeductibleCredits) {
          setPurchaseModelData({
            type: bulkMessageData?.camp_type,
            purchaseCredit:
              ReviewData?.draftDeductibleCredits > minimumCredit
                ? ReviewData?.draftDeductibleCredits
                : minimumCredit,
            minimum: ReviewData?.draftDeductibleCredits,
          })
          setPurchasePopupModal(true)
        } else {
          if (isDefaultRegion === false) {
            if (smsDataToSend?.senderType === 'dedicatedNumber') {
              smsDataToSend.senderType = 'dedicated'
            }

            if (smsDataToSend.senderType === 'businessName') {
              smsDataToSend.senderType = 'business'
            }

            if (smsDataToSend.senderType === 'customNumber') {
              smsDataToSend.senderType = 'custom'
            }
            const result = await sendFinalMessage(smsDataToSend)
            if (result?.is_error === true) {
              setSendError(result?.message)
              dispatch(stopLoadingSend())
            } else {
              dispatch(
                storeReportId({
                  id: result?.data?.bulkId,
                  camp_type: result?.data?.queueResponse?.message_type,
                  data: result?.data?.queueResponse,
                })
              )
              dispatch(stopLoadingSend())
              setSuccessPopupModal(true)
            }

            setReview(false)
            return
          }
          dispatch(sendBulkMessageData(smsDataToSend))
            .then((res: any) => {
              if (sendBulkMessageData.fulfilled.match(res)) {
                if (res?.payload?.error) {
                  let errorMessage = ''
                  if (res?.payload?.error.message) {
                    errorMessage = res?.payload?.error.message
                  }

                  if (res?.payload?.message) {
                    errorMessage = res?.payload?.message
                  }
                  setSendError(errorMessage)
                } else if (
                  res?.payload?.success &&
                  res?.payload?.messsage?.includes('waiting for admin approval')
                ) {
                  setFirstTimeSend(true)
                }
                dispatch(
                  storeReportId({
                    id: res?.payload?.bulkId,
                    camp_type: res?.payload?.queueResponse?.addedBulk?.camp_type,
                  })
                )
                setReview(false)
                setSuccessPopupModal(true)
                if (!(isAdmin === 'true')) dispatch(FirstTimeApprovalData())
              } else {
                let errorMessage = 'something wrong when send data to server'
                if (res?.payload) {
                  errorMessage = res?.payload
                }
                setSendError(errorMessage)
                setSuccessPopupModal(true)
              }
              dispatch(stopLoadingSend())
            })
            .catch((error: any) => {
              setSendError(error)
              setSuccessPopupModal(true)
            })
        }
      } else {
        if (bulkMessageData.gif !== '' && bulkMessageData.gif !== undefined) {
          let mmsGifData: any = {
            ulid: bulkULID,
            sender: bulkMessageData?.sender?.value,
            senderType: bulkMessageData?.senderType,
            message: bulkMessageData?.optout
              ? replaceMessageWith(bulkMessageData?.message, '') +
                ' ' +
                `${ENV().REACT_APP_OPTOUT}/xxxxx`
              : replaceMessageWith(bulkMessageData?.message, ''),
            camp_type: bulkMessageData?.camp_type,
            gif: bulkMessageData?.gif,
            subject: bulkMessageData.subject,
            name: bulkMessageData.name,
            landingPage: bulkMessageData.landingPageId ? true : false,
            optout: bulkMessageData?.optout ? bulkMessageData?.optout : false,
            replyStopToOptOut: bulkMessageData?.replyStopToOptOut
              ? bulkMessageData?.replyStopToOptOut
              : false,
            abTest: bulkMessageData?.abTest,
            messageSecond: bulkMessageData?.optoutSecond
              ? replaceMessageWith(bulkMessageData?.messageSecond, '') +
                ' ' +
                `${ENV().REACT_APP_OPTOUT}/xxxxx`
              : replaceMessageWith(bulkMessageData?.messageSecond, ''),
            landingPageSecond: bulkMessageData.landingPageIdSecond ? true : false,
            optoutSecond: bulkMessageData?.optoutSecond ? bulkMessageData?.optoutSecond : false,
            replyStopToOptOutSecond: bulkMessageData?.replyStopToOptOutSecond
              ? bulkMessageData?.replyStopToOptOutSecond
              : false,
          }
          if (bulkMessageData?.contacts?.length > 0 && bulkMessageData?.contacts !== undefined) {
            mmsGifData.contacts = JSON.stringify(bulkMessageData?.contacts)
          } else {
            mmsGifData.to = JSON.stringify(bulkMessageData.to)
          }
          if (bulkMessageData?.staggerMessages === true) {
            mmsGifData.staggerMessages = bulkMessageData?.staggerMessages
            mmsGifData.interval = bulkMessageData?.interval
            mmsGifData.quantity = bulkMessageData?.quantity
          }

          if (bulkMessageData?.isIntervalSend === true) {
            mmsGifData.isIntervalSend = bulkMessageData?.isIntervalSend
            mmsGifData.interval = bulkMessageData?.interval
          }
          if (
            bulkMessageData?.longUrl !== '' &&
            bulkMessageData?.longUrl !== undefined &&
            bulkMessageData?.longUrl?.length > 0
          ) {
            mmsGifData.longUrl = JSON.stringify(bulkMessageData?.longUrl)
          }

          if (
            bulkMessageData?.longUrlSecond !== '' &&
            bulkMessageData?.longUrlSecond !== undefined &&
            bulkMessageData?.longUrlSecond?.length > 0
          ) {
            mmsGifData.longUrlSecond = JSON.stringify(bulkMessageData?.longUrlSecond)
          }

          if (
            bulkMessageData?.optoutId !== '' &&
            bulkMessageData?.optoutId !== undefined &&
            bulkMessageData?.optoutId !== null
          ) {
            mmsGifData.optoutId = bulkMessageData?.optoutId
          }
          if (
            bulkMessageData?.optoutIdSecond !== '' &&
            bulkMessageData?.optoutIdSecond !== undefined &&
            bulkMessageData?.optoutIdSecond !== null
          ) {
            mmsGifData.optoutIdSecond = bulkMessageData?.optoutIdSecond
          }
          if (bulkMessageData?.when !== 'now') {
            mmsGifData.scheduleAt = bulkMessageData?.scheduledAt
          }
          if (bulkMessageData?.whenSecond !== 'now') {
            mmsGifData.scheduleAtSecond = bulkMessageData?.scheduledAtSecond
          }
          if (bulkMessageData.landingPageId !== '' && bulkMessageData.landingPageId !== undefined) {
            mmsGifData.landingPageId = bulkMessageData.landingPageId
          }
          if (
            bulkMessageData.landingPageIdSecond !== '' &&
            bulkMessageData.landingPageIdSecond !== undefined
          ) {
            mmsGifData.landingPageIdSecond = bulkMessageData.landingPageIdSecond
          }

          if (bulkMessageData?.forwardReplyTo !== '') {
            mmsGifData.forwardReplyTo = bulkMessageData.forwardReplyTo
          }

          if (!globalSettings?.includes(GLOBAL_SETTINGS_TYPE.BULK_MMS_REPLY_STOP_OUTPUT)) {
            mmsGifData = {
              ...mmsGifData,
              optout: false,
              replyStopToOptOut: false,
              optoutSecond: false,
              replyStopToOptOutSecond: false,
            }
          } else {
            const isAlphaSender = ['businessName', 'customNumber'].includes(
              bulkMessageData?.senderType
            )
            if (!mmsGifData.optout && !mmsGifData.replyStopToOptOut) {
              if (isAlphaSender) {
                mmsGifData.replyStopToOptOut = false
                mmsGifData.optout = true
                mmsGifData.optoutId = mmsGifData.optoutId || optoutList?.at(0)?._id || ''
              } else {
                mmsGifData.replyStopToOptOut = true
              }
            }
            if (
              mmsGifData.abTest &&
              !mmsGifData.optoutSecond &&
              !mmsGifData.replyStopToOptOutSecond
            ) {
              if (isAlphaSender) {
                mmsGifData.replyStopToOptOutSecond = false
                mmsGifData.optoutSecond = true
                mmsGifData.optoutIdSecond =
                  mmsGifData.optoutIdSecond || optoutList?.at(0)?._id || ''
              } else {
                mmsGifData.replyStopToOptOutSecond = true
              }
            }
          }

          if (mmsGifData && mmsGifData.scheduleAt) {
            mmsGifData.scheduleAt = toLocalTimezone(mmsGifData.scheduleAt)
          }

          if (mmsGifData && mmsGifData.scheduleAtSecond) {
            mmsGifData.scheduleAtSecond = toLocalTimezone(mmsGifData.scheduleAtSecond)
          }

          mmsGifData.message = replaceMessageWith(mmsGifData.message, '')
          mmsGifData.messageSecond = replaceMessageWith(mmsGifData.messageSecond, '')
          mmsGifData.tagNewContactIds = selectedTagIds

          setReview(true)
          let formData = new FormData()
          for (var key in mmsGifData) {
            formData.append(key, mmsGifData[key])
          }

          if (credits?.credits?.[bulkMessageData?.camp_type] < ReviewData?.draftDeductibleCredits) {
            setPurchaseModelData({
              type: bulkMessageData?.camp_type,
              purchaseCredit:
                ReviewData?.draftDeductibleCredits > minimumCredit
                  ? ReviewData?.draftDeductibleCredits
                  : minimumCredit,
              minimum: ReviewData?.draftDeductibleCredits,
            })
            setPurchasePopupModal(true)
          } else {
            dispatch(sendBulkMessagemmsData(formData))
              .then((res: any) => {
                if (sendBulkMessagemmsData.fulfilled.match(res)) {
                  if (
                    res?.payload?.message !== 'You are not allowed or Invalid sender to send sms'
                  ) {
                    if (res?.payload?.error) {
                      if (res?.payload?.error.message) {
                        setSendError(res?.payload?.error.message)
                      } else if (res?.payload?.message) {
                        setSendError(res?.payload?.message)
                      }
                    } else if (
                      res?.payload?.success &&
                      res?.payload?.messsage?.includes('waiting for admin approval')
                    ) {
                      setFirstTimeSend(true)
                    }
                    dispatch(
                      storeReportId({
                        id: res?.payload?.bulkId,
                        camp_type: res?.payload?.queueResponse?.addedBulk?.camp_type,
                      })
                    )
                    setReview(false)
                    setSuccessPopupModal(true)
                    if (!(isAdmin === 'true')) dispatch(FirstTimeApprovalData())
                  }
                } else {
                  let errorMessage = 'something wrong when send data to server'
                  if (res?.payload) {
                    errorMessage = res?.payload
                  }
                  setSendError(errorMessage)
                  setSuccessPopupModal(true)
                }
                dispatch(stopLoadingSend())
              })
              .catch((error: any) => {
                setSendError(error)
                setSuccessPopupModal(true)
              })
          }
        } else {
          let mediaData = bulkMessageData?.media ?? ''
          if (typeof mediaData == 'string') {
            if (mediaData?.startsWith('data:')) {
              mediaData = base64ToFile(mediaData)
            }
          }

          let mediaDataCondition: any =
            typeof mediaData == 'string' && mediaData !== ''
              ? JSON.stringify(bulkMessageData.urlData)
              : mediaData

          let mmsData: any = {
            ulid: bulkULID,
            sender: bulkMessageData?.sender?.value,
            message: bulkMessageData?.optout
              ? replaceMessageWith(bulkMessageData?.message, '') +
                ' ' +
                `${ENV().REACT_APP_OPTOUT}/xxxxx`
              : replaceMessageWith(bulkMessageData?.message, ''),
            senderType: bulkMessageData?.senderType,
            camp_type: bulkMessageData?.camp_type,
            media: mediaDataCondition,
            name: bulkMessageData.name,
            subject: bulkMessageData.subject,
            landingPage: bulkMessageData.landingPageId ? true : false,
            optout: bulkMessageData?.optout ? bulkMessageData?.optout : false,
            replyStopToOptOut: bulkMessageData?.replyStopToOptOut
              ? bulkMessageData?.replyStopToOptOut
              : false,
          }
          if (bulkMessageData?.contacts?.length > 0 && bulkMessageData?.contacts !== undefined) {
            mmsData.contacts = JSON.stringify(bulkMessageData?.contacts)
          } else {
            mmsData.to = JSON.stringify(bulkMessageData.to)
          }
          if (bulkMessageData?.staggerMessages === true) {
            mmsData.staggerMessages = bulkMessageData?.staggerMessages
            mmsData.interval = bulkMessageData?.interval
            mmsData.quantity = bulkMessageData?.quantity
          }
          if (bulkMessageData?.isIntervalSend === true) {
            mmsData.isIntervalSend = bulkMessageData?.isIntervalSend
            mmsData.interval = bulkMessageData?.interval
          }
          if (bulkMessageData?.longUrl?.length > 0 && bulkMessageData?.longUrl !== undefined) {
            mmsData.longUrl = JSON.stringify(bulkMessageData?.longUrl)
          }

          if (
            bulkMessageData?.longUrlSecond?.length > 0 &&
            bulkMessageData?.longUrlSecond !== undefined
          ) {
            mmsData.longUrlSecond = JSON.stringify(bulkMessageData?.longUrlSecond)
          }

          if (
            bulkMessageData?.optoutId !== '' &&
            bulkMessageData?.optoutId !== undefined &&
            bulkMessageData?.optoutId !== null
          ) {
            mmsData.optoutId = bulkMessageData?.optoutId
          }
          if (
            bulkMessageData?.optoutIdSecond !== '' &&
            bulkMessageData?.optoutIdSecond !== undefined &&
            bulkMessageData?.optoutIdSecond !== null
          ) {
            mmsData.optoutIdSecond = bulkMessageData?.optoutIdSecond
          }
          if (bulkMessageData?.when !== 'now') {
            mmsData.scheduleAt = bulkMessageData?.scheduledAt
          }
          if (bulkMessageData?.whenSecond !== 'now') {
            mmsData.scheduleAtSecond = bulkMessageData?.scheduleAtSecond
          }
          if (bulkMessageData.landingPageId !== '' && bulkMessageData.landingPageId !== undefined) {
            mmsData.landingPageId = bulkMessageData.landingPageId
          }
          if (
            bulkMessageData.landingPageIdSecond !== '' &&
            bulkMessageData.landingPageIdSecond !== undefined
          ) {
            mmsData.landingPageIdSecond = bulkMessageData.landingPageIdSecond
          }

          if (!globalSettings.includes(GLOBAL_SETTINGS_TYPE.BULK_MMS_REPLY_STOP_OUTPUT)) {
            mmsData = {
              ...mmsData,
              optout: false,
              replyStopToOptOut: false,
              optoutSecond: false,
              replyStopToOptOutSecond: false,
            }
          } else {
            const isAlphaSender = ['businessName', 'customNumber'].includes(
              bulkMessageData?.senderType
            )
            if (!mmsData.optout && !mmsData.replyStopToOptOut) {
              if (isAlphaSender) {
                mmsData.replyStopToOptOut = false
                mmsData.optout = true
                mmsData.optoutId = mmsData.optoutId || optoutList?.at(0)?._id || ''
              } else {
                mmsData.replyStopToOptOut = true
              }
            }
          }

          if (mmsData && mmsData.scheduleAt) {
            mmsData.scheduleAt = toLocalTimezone(mmsData.scheduleAt)
          }

          if (mmsData && mmsData.scheduleAtSecond) {
            mmsData.scheduleAtSecond = toLocalTimezone(mmsData.scheduleAtSecond)
          }

          mmsData.tagNewContactIds = selectedTagIds

          setReview(true)

          let formData = new FormData()
          for (var field in mmsData) {
            formData.append(field, mmsData[field])
          }

          if (credits?.credits?.[bulkMessageData?.camp_type] < ReviewData?.draftDeductibleCredits) {
            setPurchaseModelData({
              type: bulkMessageData?.camp_type,
              purchaseCredit:
                ReviewData?.draftDeductibleCredits > minimumCredit
                  ? ReviewData?.draftDeductibleCredits
                  : minimumCredit,
              minimum: ReviewData?.draftDeductibleCredits,
            })
            setPurchasePopupModal(true)
          } else {
            dispatch(sendBulkMessagemmsData(formData))
              .then((res: any) => {
                if (sendBulkMessagemmsData.fulfilled.match(res)) {
                  if (
                    res?.payload?.message !== 'You are not allowed or Invalid sender to send sms'
                  ) {
                    if (res?.payload?.error) {
                      if (res?.payload?.error.message) {
                        setSendError(res?.payload?.error.message)
                      } else if (res?.payload?.message) {
                        setSendError(res?.payload?.message)
                      }
                    } else if (
                      res?.payload?.success &&
                      res?.payload?.messsage?.includes('waiting for admin approval')
                    ) {
                      setFirstTimeSend(true)
                    }
                    dispatch(
                      storeReportId({
                        id: res?.payload?.bulkId,
                        camp_type: res?.payload?.queueResponse?.addedBulk?.camp_type,
                      })
                    )
                    setReview(false)
                    setSuccessPopupModal(true)
                    if (!(isAdmin === 'true')) dispatch(FirstTimeApprovalData())
                    dispatch(stopLoadingSend())
                  }
                } else {
                  let errorMessage = 'something wrong when send data to server'
                  if (res?.payload) {
                    errorMessage = res?.payload
                  }
                  setSendError(errorMessage)
                  setSuccessPopupModal(true)
                }
                dispatch(stopLoadingSend())
              })
              .catch((error: any) => {
                setSendError(error)
                setSuccessPopupModal(true)
              })
          }
        }
      }
    } else {
      setShowAlert(true)
      setAlertMessage('Your selected scheduler time has already past, please select future time ')
    }
  }

  const validation = (value: any) => {
    const err: any = {}

    if (value.name === '' || value.name === undefined) {
      err.name = 'Name is required'
    }

    if (value.camp_type === '' || value.camp_type === undefined) {
      err.message = 'Message is required'
    }

    if (value.camp_type === 'mms' && value.media === '' && value.gif === '') {
      err.message = 'Message Media is required'
    }

    if (value.message === '' || value.message === undefined) {
      err.message = 'Message is required'
    }

    if (value?.contacts?.length < 0 || value?.contacts === undefined) {
      if (value.to.selectedType === '' || value.to.selectedType === undefined) {
        err.to = 'Select To  is required'
      }
      if (value.to.value === '' || value.to.value === undefined) {
        err.to = 'Select To  is required'
      }
    }
    if (value.sender?.value === '' || value.sender?.value === undefined) {
      err.sender = 'Select sender  is required'
    }
    if (value.when === '' || value.when === undefined) {
      err.when = 'Select when  is required'
    }
    if (value.staggerMessages === true) {
      if (value.interval === '' || value.interval === undefined) {
        err.when = 'Select interval  is required'
      }
      if (value.quantity === '' || value.quantity === undefined) {
        err.when = 'Select quantity  is required'
      }
    }

    const shortUrl = ENV().REACT_APP_SHORTURL
    const landingPageUrl = `${shortUrl}/Lxxxxx`

    if (value?.message?.includes(shortUrl) && !value?.message?.includes(landingPageUrl)) {
      const text = value?.message

      const regex = new RegExp(`${shortUrl?.replace(/\./g, '\\.')}\\/([a-zA-Z0-9_-]+)`, 'gmi')
      const matches = [...text.matchAll(regex)].map((match) => match.at(1))

      const allExist = matches.every((short) =>
        value.longUrl.some((it: any) => it.shortUrl === short)
      )

      if (!allExist) {
        err.message = "Message contains tracking link but doesn't have short url been created"
      }

      const existLink = matches.every((short) =>
        ShortLinkList.some((it: any) => it.shortUrl === short)
      )

      if (!existLink) {
        err.message = "Message contains tracking link but doesn't have short url been created"
      }
    }

    setError(err)
    return err
  }

  const sendTestMessage = (e: any) => {
    e.preventDefault()
    setSendFlag(true)
    setTimeout(() => setSendFlag(false), 3000)

    const minimumCredit =
      bulkMessageData?.camp_type === 'sms'
        ? Number(userData?.MIN_PURCHASES_SMS_CERDIT ?? 20)
        : Number(userData?.MIN_PURCHASES_MMS_CERDIT ?? 20)
    if (bulkMessageData?.message !== '' && testNumber !== '') {
      if (bulkMessageData?.camp_type === 'sms') {
        const iid =
          bulkMessageData?.landingPageId !== '' && bulkMessageData?.landingPageId !== undefined

        let smsDataToSend: any = {
          contacts: [testNumber],
          countryCode: '61',
          message: bulkMessageData?.message,
          sender: bulkMessageData?.sender?.value,
          senderType: bulkMessageData?.senderType,
          landingPage: bulkMessageData.landingPageId ? true : false,
          optout: bulkMessageData?.optout ? bulkMessageData?.optout : false,
          replyStopToOptOut: bulkMessageData?.replyStopToOptOut
            ? bulkMessageData?.replyStopToOptOut
            : false,
        }
        if (bulkMessageData?.sender?.value === '') {
          smsDataToSend.sender = '#SharedNum#'
        }

        if (bulkMessageData?.longUrl !== '') {
          smsDataToSend.longUrl = bulkMessageData?.longUrl
        }
        if (
          bulkMessageData?.optoutId !== '' &&
          bulkMessageData?.optoutId !== undefined &&
          bulkMessageData?.optoutId !== null
        ) {
          smsDataToSend.optoutId = bulkMessageData?.optoutId
        }

        if (bulkMessageData.landingPageId !== '') {
          smsDataToSend.landingPageId = bulkMessageData.landingPageId
        }

        // if (credits?.credits?.[bulkMessageData?.camp_type] < ReviewData?.draftDeductibleCredits) {
        //   setPurchaseModelData({
        //     type: bulkMessageData?.camp_type,
        //     purchaseCredit:
        //       ReviewData?.draftDeductibleCredits > minimumCredit
        //         ? ReviewData?.draftDeductibleCredits
        //         : minimumCredit,
        //     minimum: ReviewData?.draftDeductibleCredits,
        //   })
        //   setPurchasePopupModal(true)
        // } else {
        dispatch(fetchAsyncQuickSms(smsDataToSend))
        // }
      } else {
        if (bulkMessageData.gif !== '' && bulkMessageData.gif !== undefined) {
          let mmsGifData: any = {
            contacts: JSON.stringify([testNumber]),
            message: replaceMessageWith(bulkMessageData?.message, ''),
            media: '',
            gif: bulkMessageData?.gif,
            subject: bulkMessageData?.subject,
            sender: bulkMessageData?.sender?.value,
            senderType: bulkMessageData?.senderType,

            landingPage: bulkMessageData.landingPageId ? true : false,
            optout: bulkMessageData?.optout ? bulkMessageData?.optout : false,
            replyStopToOptOut: bulkMessageData?.replyStopToOptOut
              ? bulkMessageData?.replyStopToOptOut
              : false,
          }
          if (bulkMessageData?.sender?.value == '') {
            mmsGifData.sender = '#SharedNum#'
          }

          if (bulkMessageData?.longUrl !== '') {
            mmsGifData.longUrl = JSON.stringify(bulkMessageData?.longUrl)
          }
          if (bulkMessageData?.longUrlSecond !== '') {
            mmsGifData.longUrlSecond = JSON.stringify(bulkMessageData?.longUrlSecond)
          }
          if (
            bulkMessageData?.optoutId !== '' &&
            bulkMessageData?.optoutId !== undefined &&
            bulkMessageData?.optoutId !== null
          ) {
            mmsGifData.optoutId = bulkMessageData?.optoutId
          }
          if (bulkMessageData.landingPageId !== '') {
            mmsGifData.landingPageId = bulkMessageData.landingPageId
          }

          let formData = new FormData()
          for (var key in mmsGifData) {
            formData.append(key, mmsGifData[key])
          }
          // if (credits?.credits?.[bulkMessageData?.camp_type] < ReviewData?.draftDeductibleCredits) {
          //   setPurchaseModelData({
          //     type: bulkMessageData?.camp_type,
          //     purchaseCredit:
          //       ReviewData?.draftDeductibleCredits > minimumCredit
          //         ? ReviewData?.draftDeductibleCredits
          //         : minimumCredit,
          //     minimum: ReviewData?.draftDeductibleCredits,
          //   })
          //   setPurchasePopupModal(true)
          // } else {
          dispatch(fetchAsyncQuickMms(formData))
          // }
        } else {
          const isFile = typeof bulkMessageData.media === 'object'
          const isImage = isBase64Image(bulkMessageData?.media)

          const media = isImage
            ? base64ToFile(bulkMessageData?.media)
            : isFile
            ? bulkMessageData.media
            : JSON.stringify({
                filetype: bulkMessageData?.urlData?.filetype || bulkMessageData?.mediaType,
                url: bulkMessageData?.urlData?.url || bulkMessageData?.media,
                mediaType: 'image',
                fileName: bulkMessageData?.urlData?.fileName || bulkMessageData?.fileName,
              })

          let mmsData: any = {
            contacts: JSON.stringify([testNumber]),
            message: replaceMessageWith(bulkMessageData?.message, ''),
            gif: '',
            media,
            sender: bulkMessageData?.sender?.value,
            senderType: bulkMessageData?.senderType,
            subject: bulkMessageData?.subject,

            // name: bulkMessageData.name,

            landingPage: bulkMessageData.landingPageId ? true : false,
            optout: bulkMessageData?.optout ? bulkMessageData?.optout : false,
            replyStopToOptOut: bulkMessageData?.replyStopToOptOut
              ? bulkMessageData?.replyStopToOptOut
              : false,
          }

          if (bulkMessageData?.longUrl !== '') {
            mmsData.longUrl = JSON.stringify(bulkMessageData?.longUrl)
          }
          if (bulkMessageData?.longUrlSecond !== '') {
            mmsData.longUrlSecond = JSON.stringify(bulkMessageData?.longUrlSecond)
          }
          if (
            bulkMessageData?.optoutId !== '' &&
            bulkMessageData?.optoutId !== undefined &&
            bulkMessageData?.optoutId !== null
          ) {
            mmsData.optoutId = bulkMessageData?.optoutId
          }

          if (bulkMessageData.landingPageId !== '') {
            mmsData.landingPageId = bulkMessageData.landingPageId
          }
          if (bulkMessageData?.sender?.value === '') {
            mmsData.sender = '#SharedNum#'
          }

          let formData = new FormData()
          // eslint-disable-next-line @typescript-eslint/no-redeclare
          for (var key in mmsData) {
            formData.append(key, mmsData[key])
          }
          // if (credits?.credits?.[bulkMessageData?.camp_type] < ReviewData?.draftDeductibleCredits) {
          //   setPurchaseModelData({
          //     type: bulkMessageData?.camp_type,
          //     purchaseCredit:
          //       ReviewData?.draftDeductibleCredits > minimumCredit
          //         ? ReviewData?.draftDeductibleCredits
          //         : minimumCredit,
          //     minimum: ReviewData?.draftDeductibleCredits,
          //   })
          // setPurchasePopupModal(true)
          // } else {
          dispatch(fetchAsyncQuickMms(formData))
          // }
        }
      }
    }
  }
  ///////////////////////////////////////USE MEMO//////////////////////////////////////

  const WarningAlert = useMemo(
    () => (
      <AlertMessageBox
        message={alertMessage}
        show={showAlert}
        handleClose={() => setShowAlert(false)}
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [showAlert]
  )

  const renderOptOutText = (second = false) => {
    let message = ''

    const settingType =
      bulkMessageData.camp_type === 'sms'
        ? GLOBAL_SETTINGS_TYPE.BULK_SMS_REPLY_STOP_OUTPUT
        : GLOBAL_SETTINGS_TYPE.BULK_MMS_REPLY_STOP_OUTPUT

    if (!globalSettings?.includes(settingType)) {
      return ''
    }

    if (second) {
      if (bulkMessageData?.optoutSecond) {
        message = `STOP: ${optOutUrl}/xxxxxx`
      }

      if (bulkMessageData?.replyStopToOptOutSecond) {
        message = "Reply 'STOP' to opt-out"
      }
    }

    if (bulkMessageData?.optout) {
      message = `STOP: ${optOutUrl}/xxxxxx`
    }

    if (bulkMessageData?.replyStopToOptOut) {
      message = "Reply 'STOP' to opt-out"
    }

    return message
  }

  const removeOptOutOrReply = (message: string) => {
    let replacedMessage = renderShortLink(message)

    if (replacedMessage?.includes("Reply 'STOP' to opt-ou")) {
      return replaceMessageWith(replacedMessage, '')
    }

    if (replacedMessage?.includes('STOP: stoptxt.au/v')) {
      return replaceMessageWith(replacedMessage, '')
    }

    return replacedMessage
  }

  const renderShortLink = (textMessage: string) => {
    if (bulkMessageData?.longUrlSecond?.length > 0) {
      const uniqueUrl = Array.from(
        new Map(bulkMessageData.longUrlSecond.map((item: any) => [item.shortUrl, item])).values()
      )
      for (let index = 0; index < uniqueUrl.length; index++) {
        const element: any = uniqueUrl[index]
        let tempShortUrl = `${defaultShortUrl}/${element.shortUrl}`

        if (textMessage.split(tempShortUrl).length - 1) {
          textMessage = textMessage.replace(tempShortUrl, `${tempShortUrl}-xxxxx`)
        }
      }

      return textMessage
    }

    if (bulkMessageData?.longUrl?.length > 0) {
      const uniqueUrl = Array.from(
        new Map(bulkMessageData.longUrl.map((item: any) => [item.shortUrl, item])).values()
      )
      for (let index = 0; index < uniqueUrl.length; index++) {
        const element: any = uniqueUrl[index]
        let tempShortUrl = `${defaultShortUrl}/${element.shortUrl}`

        if (textMessage.split(tempShortUrl).length - 1) {
          textMessage = textMessage.replace(tempShortUrl, `${tempShortUrl}-xxxxx`)
        }
      }

      return textMessage
    }

    return textMessage
  }

  const renderOptOutTextMessage = (textMessage: any, second = false) => {
    let message = ''

    const settingType =
      bulkMessageData.camp_type === 'sms'
        ? GLOBAL_SETTINGS_TYPE.BULK_SMS_REPLY_STOP_OUTPUT
        : GLOBAL_SETTINGS_TYPE.BULK_MMS_REPLY_STOP_OUTPUT

    if (!globalSettings?.includes(settingType)) {
      return ''
    }

    if (second) {
      if (bulkMessageData?.optoutSecond !== true) {
        if (bulkMessageData.replyStopToOptOutSecond) {
          message = "Reply 'STOP' to opt-out"
        }
      } else {
        if (bulkMessageData?.optoutSecond) {
          message = `STOP: ${optOutUrl}/xxxxxx`
        }
      }

      // message = renderShortLink(textMessage, true)
      if (removeOptOutOrReply(textMessage) !== '') {
        return <span>{message}</span>
      }
    }

    if (bulkMessageData?.optout !== true) {
      if (bulkMessageData.replyStopToOptOut) {
        message = "Reply 'STOP' to opt-out"
      }
    } else {
      if (bulkMessageData?.optout) {
        message = `STOP: ${optOutUrl}/xxxxxx`
      }
    }

    if (removeOptOutOrReply(textMessage) !== '') {
      return <span>{message}</span>
    }
  }

  const isCompleteGroup = groupData?.data?.status === 'Completed'

  const previews = ReviewData?.previews || []

  return (
    <>
      {contectListPopup}
      {contectSegmentListPopup}
      {purchaseModal}
      {successModal}
      {WarningAlert}

      <div className='m-n5 new_message'>
        <div className='row align-items-start'>
          {!review ? (
            <div className='col-xl-8 mb-10' style={{paddingRight: '30px'}}>
              <div
                className='d-flex justify-content-center'
                style={{marginBottom: '42px', width: '100%'}}
              >
                <Stepper
                  steps={[
                    {
                      key: 'gettingStarted',
                      label: 'Getting Started',
                    },
                    {
                      key: 'to',
                      label: 'To',
                    },
                    {
                      key: 'from',
                      label: 'From',
                    },
                    {
                      key: 'message',
                      label: 'Message',
                    },
                    {
                      key: 'when',
                      label: 'When',
                    },
                  ]}
                  activeSteps={checkStep}
                  completedSteps={completedSteps}
                />
              </div>
              <div className='accordion' id='accordionExample'>
                <div
                  className={`accordion-item ${
                    Object.keys(error)?.includes('name') && 'accordion-boader'
                  }`}
                >
                  <GettingStartedV2
                    validation={validation}
                    setBulkMessageData={setBulkMessageData}
                    bulkMessageData={bulkMessageData}
                    error={error}
                    setError={setError}
                    checkStep={checkStep}
                    setCheckStep={setCheckStep}
                    setIsForwardIncomingMessage={setIsForwardIncomingMessage}
                  />
                </div>
                {/* //////////////////////////////////// */}
                <div
                  className={`accordion-item ${
                    Object.keys(error)?.includes('to') && 'accordion-boader'
                  }`}
                  style={{
                    pointerEvents: isCompleteGroup ? 'auto' : 'none',
                    opacity: isCompleteGroup ? 1 : 0.5,
                  }}
                >
                  <BulkMessageSendToV2
                    errordata={error}
                    setErrorData={setError}
                    setContectListModel={setContectListModel}
                    setSegmentContectListModel={setSegmentContectListModel}
                    segmentAndTags={
                      isDefaultRegion ? segmentAndTags : [{label: 'Tags', options: tagRegion}]
                    }
                    setBulkMessageData={setBulkMessageData}
                    bulkMessageData={bulkMessageData}
                    quickSms={bulkMessageData?.camp_type == 'sms'}
                    checkStep={checkStep}
                    setCheckStep={setCheckStep}
                    handleSearchTag={handleSearchTag}
                  />
                </div>
                {/* /////////////////Bulk_Message_Send_From_V2/////////////////// */}
                <div
                  className={`accordion-item ${
                    Object.keys(error)?.includes('sender') && 'accordion-boader'
                  }`}
                >
                  <BulkMessageSendFromV2
                    error={error}
                    setError={setError}
                    setMMSError={setMMSError}
                    setBulkMessageData={setBulkMessageData}
                    bulkMessageData={bulkMessageData}
                    checkStep={checkStep}
                    setCheckStep={setCheckStep}
                  />
                  {mmsError ? (
                    <p
                      style={{
                        margin: 0,
                        fontSize: '14px',
                        color: 'red',
                        padding: '0px 10px 10px 20px',
                      }}
                    >
                      Error: mms can not be sent with customer business name or your own number
                    </p>
                  ) : null}
                </div>
                {/* /////////////////  Message/////////////////// */}
                <div
                  className={`accordion-item ${
                    Object.keys(error)?.includes('message') && 'accordion-boader'
                  }`}
                >
                  <BulkMessageMesssageBoxV2
                    error={error}
                    setError={setError}
                    setMMSError={setMMSError}
                    setBulkMessageData={setBulkMessageData}
                    bulkMessageData={bulkMessageData}
                    checkStep={checkStep}
                    setCheckStep={setCheckStep}
                    setIsForwardIncomingMessage={setIsForwardIncomingMessage}
                  />

                  {Object.keys(error)?.includes('message') ? (
                    <p
                      style={{
                        margin: 0,
                        fontSize: '14px',
                        color: 'red',
                        padding: '0px 10px 10px 20px',
                      }}
                    >
                      {error?.message}
                    </p>
                  ) : null}
                </div>
                {/* //////////////////////////////////////////////////////// */}
                <div
                  className={`accordion-item ${
                    Object.keys(error)?.includes('when') && 'accordion-boader'
                  }`}
                >
                  <BulkMessagewhenv2
                    isForwardIncomingMessage={isForwardIncomingMessage}
                    setIsForwardIncomingMessage={setIsForwardIncomingMessage}
                    error={error}
                    setError={setError}
                    setBulkMessageData={setBulkMessageData}
                    bulkMessageData={bulkMessageData}
                    checkStep={checkStep}
                    setCheckStep={setCheckStep}
                  />
                </div>
              </div>
              <div className='newmessage_btns'>
                <div className='credit invisible'>
                  <span>Estimated credits: {countWords(bulkMessageData?.message)}</span>
                </div>
                <div className='btn-right'>
                  {!bulkMessageData?.abTest && isDefaultRegion ? (
                    <button
                      onClick={handleSaveData}
                      className='btn btn-outline-primary'
                      data-testid='btnSaveCampaign'
                      style={{borderRadius: '12px', border: '1px solid #7950f2'}}
                    >
                      Save
                    </button>
                  ) : null}

                  <button
                    onClick={handelSendData}
                    className='btn btn-primary'
                    data-testid='btnReview&Send'
                    style={{borderRadius: '12px'}}
                    disabled={!isAllStepCompleted}
                  >
                    Review & Send
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <>
              <ReviewBulkMessageData
                bulkMessageData={bulkMessageData}
                segmentAndTags={segmentAndTags}
                setBulkMessageData={setBulkMessageData}
                checkStep={checkStep}
                setCheckStep={setCheckStep}
                setReview={setReview}
                handleSaveData={handleSaveData}
                sendBulkMessage={sendBulkMessage}
                setSelectedTagIds={setSelectedTagIds}
              />
            </>
          )}

          {/* ////////////////////////////////////////MOBILE DISPLAY//////////////////////////// */}
          <div className='col-xl-4 bg-white ps-xl-12 scroll_aside' style={{borderRadius: '6px'}}>
            <div className='NewBulkMsgPreview'>
              <div className='new_newmessage_right new_newmessage_right_mobile'>
                <h5>Preview {previews?.length ? `- Screen ${previewIndex + 1}` : ''}</h5>
                <nav>
                  <div
                    className='nav nav-tabs'
                    style={{border: 'none'}}
                    id='nav-tab'
                    role='tablist'
                    data-testid='previewMessageOption'
                  >
                    <button
                      className='nav-link active rounded-end-0'
                      id='nav-home1-tab'
                      data-bs-toggle='tab'
                      data-bs-target='#nav-home1-quick'
                      type='button'
                      role='tab'
                      aria-controls='nav-home1'
                      aria-selected='true'
                    >
                      <KTSVG
                        path='/media/icons/duotune/locked/unlocked.svg'
                        style={{width: '16px', height: '16px', marginRight: '2px'}}
                      />
                      <span className='text'>In Message</span>
                    </button>
                    <button
                      className='nav-link rounded-start-0'
                      id='nav-profile1-tab'
                      data-bs-toggle='tab'
                      data-bs-target='#nav-profile1-quick'
                      type='button'
                      role='tab'
                      aria-controls='nav-profile1-quick'
                      aria-selected='false'
                    >
                      <KTSVG
                        path='/media/icons/duotune/locked/locked.svg'
                        style={{width: '16px', height: '16px', marginRight: '2px'}}
                      />
                      <span className='text'>Lockscreen</span>
                    </button>
                  </div>
                </nav>
                <div className='tab-content' id='nav-tabContent'>
                  <div
                    className='active fade show tab-pane'
                    id='nav-home1-quick'
                    role='tabpanel'
                    aria-labelledby='nav-home1-tab'
                  >
                    <div
                      className='active fade show tab-pane'
                      id='nav-home1-quick'
                      role='tabpanel'
                      aria-labelledby='nav-home-tab'
                    >
                      <div style={{position: 'relative'}}>
                        <div
                          className='grey-bg mobile-bg-wrapper new_mobile'
                          style={{
                            backgroundImage: `url(${toAbsoluteUrl('/media/mobile/NewMobile.png')})`,
                          }}
                        >
                          <div className='mobile-inner'>
                            <div className='mobile-head'>
                              <strong
                                className='d-block p-6 text-center msg-mobile-title px-12'
                                data-testid='txtPreviewSenderID'
                              >
                                <KTSVG
                                  className='svg-icon-8'
                                  path='/media/icons/duotune/arrows/mobile_left_arrow.svg'
                                />{' '}
                                {bulkMessageData?.senderType === '#SharedNum#'
                                  ? '#SharedNum#'
                                  : bulkMessageData?.sender?.value || 'Sender ID'}
                              </strong>
                            </div>
                            <div className='mobile-body'>
                              <div className='message-box' data-testid='previewMessageBox'>
                                <div className='text-center time'>Today {moment().format('LT')}</div>
                                {bulkMessageData?.camp_type === 'mms' && (
                                  <div className='message'>
                                    {bulkMessageData.subject || 'Engaging subject here'}
                                  </div>
                                )}
                                {bulkMessageData?.camp_type === 'mms' &&
                                  bulkMessageData?.media !== '' &&
                                  bulkMessageData?.media !== undefined && (
                                    <>
                                      {typeof bulkMessageData?.media == 'string' && (
                                        <span>
                                          {!bulkMessageData?.mediaType
                                            ?.split('/')
                                            ?.includes('video') &&
                                          !bulkMessageData?.mediaType?.includes('vcard') ? (
                                            <img
                                              src={bulkMessageData?.media}
                                              alt=''
                                              className='rounded-3 mb-2'
                                            />
                                          ) : (
                                            <video
                                              src={bulkMessageData?.media}
                                              width={300}
                                              height={100}
                                              controls
                                            />
                                          )}
                                        </span>
                                      )}
                                      {typeof bulkMessageData?.media !== 'string' &&
                                        bulkMessageData?.media?.type && (
                                          <span>
                                            {!bulkMessageData?.media?.type
                                              ?.split('/')
                                              ?.includes('video') &&
                                              !bulkMessageData?.mediaType
                                                ?.split('/')
                                                ?.includes('vcard') && (
                                                <img
                                                  src={URL.createObjectURL(bulkMessageData?.media)}
                                                  alt=''
                                                  className='rounded-3 mb-2'
                                                />
                                              )}

                                            {bulkMessageData?.media?.type
                                              ?.split('/')
                                              ?.includes('video') && (
                                              <video
                                                src={URL.createObjectURL(bulkMessageData?.media)}
                                                width={'100%'}
                                                height={'auto'}
                                                controls
                                              />
                                            )}

                                            {bulkMessageData?.media?.type?.includes('vcard') && (
                                              <span>
                                                <VCardPreview file={bulkMessageData?.media} />
                                              </span>
                                            )}
                                          </span>
                                        )}
                                    </>
                                  )}
                                {bulkMessageData?.camp_type === 'mms' ? (
                                  bulkMessageData?.gif !== '' &&
                                  bulkMessageData?.gif !== undefined ? (
                                    <span>
                                      <img
                                        src={bulkMessageData?.gif}
                                        alt=''
                                        className='rounded-3 mb-2'
                                      />
                                    </span>
                                  ) : !bulkMessageData?.media ? (
                                    <span>
                                      <img
                                        src='media/gif/default_mms_gif.gif'
                                        alt=''
                                        className='rounded-3 mb-2'
                                      />
                                    </span>
                                  ) : null
                                ) : null}

                                <div className='message'>
                                  {previews.length > 0 ? (
                                    <div className='preview-message-item'>
                                      {previews[previewIndex]?.message}
                                    </div>
                                  ) : (
                                    <pre className='preview'>{`${
                                      removeOptOutOrReply(bulkMessageData?.message) ||
                                      `1. 'Insert field' to add client name
2. Smartlink to track clicks
3. Sign-off with your name & contact
4. 'stoptxt' opt-out survey
                                                             
${renderOptOutText()}`
                                    }`}</pre>
                                  )}
                                  {!previews.length &&
                                    renderOptOutTextMessage(bulkMessageData?.message)}
                                </div>
                              </div>
                              <div className='send-msg'>
                                <input type='text' />
                                <a
                                  href='#'
                                  className='send_btn'
                                  style={{
                                    backgroundImage: `url(${toAbsoluteUrl(
                                      '/media/mobile/send.svg'
                                    )})`,
                                  }}
                                ></a>
                              </div>
                            </div>
                          </div>
                        </div>
                        {previews.length > 1 && (
                          <>
                            <button
                              className='btn btn-icon btn-sm'
                              style={{
                                position: 'absolute',
                                left: '-24px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                zIndex: 2,
                              }}
                              disabled={previewIndex === 0}
                              onClick={() => setPreviewIndex((prev) => Math.max(0, prev - 1))}
                            >
                              <KTSVG
                                className='svg-icon-8'
                                path='/media/icons/duotune/arrows/mobile_left_arrow.svg'
                              />
                            </button>
                            <button
                              className='btn btn-icon btn-sm'
                              style={{
                                position: 'absolute',
                                right: '-28px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                zIndex: 2,
                              }}
                              disabled={previewIndex === previews.length - 1}
                              onClick={() =>
                                setPreviewIndex((prev) => Math.min(previews.length - 1, prev + 1))
                              }
                            >
                              <KTSVG
                                className='svg-icon-8'
                                path='/media/icons/duotune/arrows/mobile_left_arrow.svg'
                                style={{transform: 'scaleX(-1)'}}
                              />
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                    {previews.length > 1 && (
                      <div className='preview-dots'>
                        {previews.map((_: any, index: number) => (
                          <div
                            key={index}
                            className={`preview-dot ${index === previewIndex ? 'active' : ''}`}
                            onClick={() => setPreviewIndex(index)}
                          />
                        ))}
                      </div>
                    )}
                  </div>
                  <div
                    className='fade tab-pane'
                    id='nav-profile1-quick'
                    role='tabpanel'
                    aria-labelledby='nav-profile1-tab'
                  >
                    <div
                      className='grey-bg mobile-bg-wrapper new_mobile'
                      style={{
                        backgroundImage: `url(${toAbsoluteUrl('/media/mobile/unlock-screen.svg')})`,
                      }}
                    >
                      <div className='unlock-screen-content'>
                        <div className='notification-outer'>
                          <div className='Notification-item'>
                            <div className='user-icon'>
                              <img
                                alt='Logo'
                                src={toAbsoluteUrl('/media/mobile/user-icon-notification.png')}
                              />
                            </div>
                            <div
                              className='notification-data'
                              style={{
                                width: '100%',
                              }}
                            >
                              <label htmlFor='' data-testid='txtPreviewSenderID'>
                                &#x2329;{' '}
                                {bulkMessageData?.senderType === '#SharedNum#'
                                  ? '#SharedNum#'
                                  : bulkMessageData?.sender?.value || 'Sender ID'}
                                &#12297;
                              </label>
                              <div className='nofication-detail-box' data-testid='notifMessageBox'>
                                <p>{bulkMessageData?.message || 'Engaging message here'}</p>
                                {bulkMessageData?.camp_type === 'mms' &&
                                  bulkMessageData?.media !== '' &&
                                  bulkMessageData?.media !== undefined && (
                                    <>
                                      {typeof bulkMessageData?.media == 'string' && (
                                        <span>
                                          {!bulkMessageData?.mediaType
                                            ?.split('/')
                                            ?.includes('video') ? (
                                            <img
                                              src={bulkMessageData?.media}
                                              alt='poster'
                                              className='rounded-3 mb-2'
                                              style={{
                                                width: '30px',
                                                height: '30px',
                                              }}
                                            />
                                          ) : null}
                                        </span>
                                      )}
                                      {typeof bulkMessageData?.media !== 'string' &&
                                        bulkMessageData?.media?.type && (
                                          <span>
                                            {!bulkMessageData?.media?.type
                                              ?.split('/')
                                              ?.includes('video') ? (
                                              <img
                                                src={URL.createObjectURL(bulkMessageData?.media)}
                                                alt='poster'
                                                className='rounded-3 mb-2'
                                                style={{
                                                  width: '30px',
                                                  height: '30px',
                                                }}
                                              />
                                            ) : null}
                                          </span>
                                        )}
                                    </>
                                  )}

                                {bulkMessageData?.camp_type === 'mms' ? (
                                  bulkMessageData?.gif !== '' &&
                                  bulkMessageData?.gif !== undefined ? (
                                    <span>
                                      <img
                                        src={bulkMessageData?.gif}
                                        alt='poster'
                                        className='rounded-3 mb-2'
                                        style={{
                                          width: '30px',
                                          height: '30px',
                                        }}
                                      />
                                    </span>
                                  ) : !bulkMessageData?.media ? (
                                    <span>
                                      <img
                                        src='media/gif/default_mms_gif.gif'
                                        alt='poster'
                                        className='rounded-3 mb-2'
                                        style={{
                                          width: '30px',
                                          height: '30px',
                                        }}
                                      />
                                    </span>
                                  ) : null
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* AB TEST Display Message */}
            {bulkMessageData?.abTest === true && bulkMessageData.camp_type === 'sms' && (
              <div className='NewQuickMsgPreview'>
                <div className='new_newmessage_right new_newmessage_right_mobile'>
                  <nav>
                    <div
                      className='nav nav-tabs'
                      id='nav-tab'
                      style={{border: 'none'}}
                      role='tablist'
                      data-testid='previewMessageOption'
                    >
                      <button
                        className='nav-link active rounded-end-0'
                        id='nav-home2-tab'
                        data-bs-toggle='tab'
                        data-bs-target='#nav-home2-quick'
                        type='button'
                        role='tab'
                        aria-controls='nav-home2-tab'
                        aria-selected='true'
                      >
                        <KTSVG
                          path='/media/icons/duotune/locked/unlocked.svg'
                          style={{width: '16px', height: '16px', marginRight: '2px'}}
                        />
                        <span className='text'>In Message</span>
                      </button>
                      <button
                        className='nav-link rounded-start-0'
                        id='nav-profile2-tab'
                        data-bs-toggle='tab'
                        data-bs-target='#nav-profile2-quick'
                        type='button'
                        role='tab'
                        aria-controls='nav-profile2-quick'
                        aria-selected='false'
                      >
                        <KTSVG
                          path='/media/icons/duotune/locked/locked.svg'
                          style={{width: '16px', height: '16px', marginRight: '2px'}}
                        />
                        <span className='text'>Lockscreen</span>
                      </button>
                    </div>
                  </nav>
                  <div className='tab-content' id='nav-tabContent'>
                    <div
                      className='active fade show tab-pane'
                      id='nav-home2-quick'
                      role='tabpanel'
                      aria-labelledby='nav-home2-tab'
                    >
                      <div
                        className='active fade show tab-pane'
                        id='nav-home2-quick'
                        role='tabpanel'
                        aria-labelledby='nav-home2-tab'
                      >
                        <div
                          className='grey-bg mobile-bg-wrapper new_mobile'
                          style={{
                            backgroundImage: `url(${toAbsoluteUrl('/media/mobile/NewMobile.png')})`,
                          }}
                        >
                          <div className='mobile-inner'>
                            <div className='mobile-head'>
                              <strong
                                className='d-block p-6 text-center msg-mobile-title px-12'
                                data-testid='txtPreviewSenderID'
                              >
                                <KTSVG
                                  className='svg-icon-8'
                                  path='/media/icons/duotune/arrows/mobile_left_arrow.svg'
                                />{' '}
                                {bulkMessageData?.senderType === '#SharedNum#'
                                  ? '#SharedNum#'
                                  : bulkMessageData?.sender?.value || 'Sender ID'}
                              </strong>
                            </div>
                            <div className='mobile-body'>
                              <div className='message-box' data-testid='previewMessageBox'>
                                <div className='text-center time'>
                                  Today {moment().format('LT')}
                                </div>
                                <div className='message'>
                                  <pre className='preview'>{`${
                                    removeOptOutOrReply(bulkMessageData?.messageSecond) ||
                                    `1. 'Insert field' to add client name
2. Smartlink to track clicks
3. Sign-off with your name & contact
4. 'stoptxt' opt-out survey

${renderOptOutText(true)}`
                                  }`}</pre>
                                  {renderOptOutTextMessage(bulkMessageData?.messageSecond, true)}
                                </div>
                              </div>
                              <div className='send-msg'>
                                <input type='text' />
                                <a
                                  href='#'
                                  className='send_btn'
                                  style={{
                                    backgroundImage: `url(${toAbsoluteUrl(
                                      '/media/mobile/send.svg'
                                    )})`,
                                  }}
                                ></a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className='fade tab-pane'
                      id='nav-profile2-quick'
                      role='tabpanel'
                      aria-labelledby='nav-profile2-tab'
                    >
                      <div
                        className='grey-bg mobile-bg-wrapper'
                        style={{
                          backgroundImage: `url(${toAbsoluteUrl(
                            '/media/mobile/unlock-screen.svg'
                          )})`,
                        }}
                      >
                        <div className='unlock-screen-content'>
                          <div className='notification-outer'>
                            <div className='Notification-item'>
                              <div className='user-icon'>
                                <img
                                  alt='Logo'
                                  src={toAbsoluteUrl('/media/mobile/user-icon-notification.png')}
                                />
                              </div>
                              <div className='w-100 notification-data'>
                                <label htmlFor='' data-testid='txtPreviewSenderID'>
                                  &#x2329;{' '}
                                  {bulkMessageData?.senderType === '#SharedNum#'
                                    ? '#SharedNum#'
                                    : bulkMessageData?.sender?.value || 'Sender ID'}
                                  &#12297;
                                </label>

                                <div
                                  className='nofication-detail-box'
                                  data-testid='notifMessageBox'
                                >
                                  <p>{bulkMessageData?.messageSecond || 'Engaging message here'}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* ///////////////////////////////////////////TEST YOUR MESSAGE////////////////////////// */}

            {isDefaultRegion && (
              <div className='newmessage_right'>
                <div className='msg_form'>
                  <div className='form-group w-100'>
                    <OverlayTrigger
                      placement='top'
                      overlay={
                        <Tooltip>
                          Smart links and opt out links will not work when sending testing message
                        </Tooltip>
                      }
                    >
                      <label
                        className='mb-2'
                        style={{
                          fontWeight: 600,
                          fontSize: '18px',
                          lineHeight: '21.6px',
                          letterSpacing: '-1%',
                        }}
                      >
                        Test Your Message{' '}
                      </label>
                    </OverlayTrigger>
                    <input
                      onChange={(e: any) => setTestNumber(e.target.value)}
                      type='text'
                      data-testid='inputNumberTestMessage'
                      className='form-control form-control-lg form-control-solid px-5'
                      placeholder='Enter Mobile Number'
                    />
                  </div>
                  <button
                    onClick={sendTestMessage}
                    className='btn btn-primary ms-2'
                    style={{padding: '9px'}}
                    data-testid='btnSendTestMessage'
                    disabled={!testNumber}
                  >
                    {sendFlag ? (
                      <KTSVG
                        path='/media/icons/duotune/general/gen037.svg'
                        className='m-0 svg-icon-2x svg-icon-danger'
                      />
                    ) : (
                      <KTSVG
                        path='/media/icons/duotune/general/send2.svg'
                        className='m-0 svg-icon-2x svg-icon-danger'
                      />
                    )}
                  </button>
                </div>
                <small className='d-block form-text text-muted mt-2'>
                  This test will use your credits to send
                </small>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export {NewMessageStepperV2}
